import type { ItemDTO } from "@barkup/shared";

/**
 * Hand-off between an archive view and the /report/:itemId screen.
 *
 * Reporting is its own route rather than an inline panel (writing a takedown
 * reason deserves the whole screen), but there is no GET /api/items/:id — the
 * lists are the only source of an ItemDTO. So the originating view parks the
 * item here on its way out, and ReportView picks it up to render context.
 *
 * Deliberately not reactive and not in `store`: it is a single-use baton, not
 * app state. A cold load straight onto /report/:itemId (LIFF re-entry, a
 * refresh) finds nothing here — ReportView degrades to a context-less form
 * that can still file the report, since the id in the URL is all the API needs.
 */
let target: { item: ItemDTO; returnTo: string } | null = null;

export function setReportTarget(item: ItemDTO, returnTo: string): void {
  target = { item, returnTo };
}

/** Consumes the parked item, if it is the one the route asked for. */
export function takeReportTarget(itemId: string): { item: ItemDTO; returnTo: string } | null {
  if (target?.item.id !== itemId) return null;
  const taken = target;
  target = null;
  return taken;
}
